import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, type Inbound, type InboundType, type InboundStatus } from "../api.js";
import { SERVICE_IDS, INBOUND_TYPES, INBOUND_STATUSES } from "../constants.js";

// "open" still needs someone to look at it; "resolved" is done.
function statusPill(status: InboundStatus) {
  return <span className={status === "resolved" ? "pill ok" : "pill danger"}>{status}</span>;
}

function excerpt(s: string | null, n = 60) {
  if (!s) return "—";
  return s.length > n ? `${s.slice(0, n)}…` : s;
}

export function InboundList() {
  const [type, setType] = useState<InboundType | "">("");
  const [status, setStatus] = useState<InboundStatus | "">("");
  const [service, setService] = useState<string>("");
  const [items, setItems] = useState<Inbound[]>([]);
  const [total, setTotal] = useState(0);
  const [error, setError] = useState<string | null>(null);

  async function load() {
    setError(null);
    try {
      const r = await api.listInbound({
        type: type || undefined,
        status: status || undefined,
        service: service || undefined,
        limit: 100,
      });
      setItems(r.items);
      setTotal(r.total);
    } catch (e) {
      setError((e as Error).message);
    }
  }

  useEffect(() => {
    void load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section data-testid="inbound-list">
      <div className="toolbar" style={{ marginBottom: 16 }}>
        <h1 style={{ margin: 0 }}>inbound (フィードバック・お問い合わせ)</h1>
      </div>
      <form
        className="toolbar"
        onSubmit={(e) => {
          e.preventDefault();
          void load();
        }}
        style={{ marginBottom: 12 }}
      >
        <label>type<select value={type} onChange={(e) => setType(e.target.value as InboundType | "")}>
          <option value="">(すべて)</option>
          {INBOUND_TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
        </select></label>
        <label>status<select value={status} onChange={(e) => setStatus(e.target.value as InboundStatus | "")}>
          <option value="">(すべて)</option>
          {INBOUND_STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
        </select></label>
        <label>service<select value={service} onChange={(e) => setService(e.target.value)}>
          <option value="">(すべて)</option>
          {SERVICE_IDS.map((s) => <option key={s} value={s}>{s}</option>)}
        </select></label>
        <button type="submit" className="btn secondary">絞り込む</button>
      </form>
      {error && <div className="error-banner">{error}</div>}
      {items.length === 0 ? (
        <div className="empty-state">該当する inbound はありません</div>
      ) : (
        <>
          <div style={{ color: "var(--muted)", marginBottom: 8 }}>{total} 件</div>
          <table className="list" data-testid="inbound-table">
            <thead>
              <tr><th>received</th><th>type</th><th>service</th><th>status</th><th>本文</th><th>user</th></tr>
            </thead>
            <tbody>
              {items.map((m) => (
                <tr key={m.id}>
                  <td><Link to={`/inbound/${m.id}`}>{new Date(m.received_at).toLocaleString()}</Link></td>
                  <td>{m.type}</td>
                  <td>{m.service_id}</td>
                  <td>{statusPill(m.status)}</td>
                  <td>{excerpt(m.body)}</td>
                  <td>{m.user_ref ?? "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </section>
  );
}
